const { debounce } = window.BAO.Utils

class FooterTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)
    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.setupTickerSpeed.bind(this)
      }, 500),
    )
  }

  setupTickerSpeed () {
    if (window.BAO.MediaBreakpoints.isXsViewport) return

    const tickerWidth = this.els.items.element.offsetWidth / 50
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('footer-ticker')) {
  customElements.define('footer-ticker', FooterTicker)
}
